import classnames from 'classnames'
import { FC, ReactNode } from 'react'

import { Link } from '~ui'

import styles from './Alert.module.scss'

type AlertMode = 'info' | 'error' | 'warning'

type AlertProps = {
  mode: AlertMode
  href?: string
  onClick?: ButtonClickEventT
  children?: ReactNode
}

const modeColorMap: { [key in AlertMode]: GThemeColorsNew } = {
  warning: 'yellow',
  info: 'teal',
  error: 'red',
}

const Alert: FC<AlertProps> = ({ onClick, href, mode, children }) => {
  if (!children) {
    return null
  }

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        className={classnames(
          'rounded-lg p-4 border glow-text-opacity-10 border-g-dividers bg-g-elevated',
          styles.alert,
          styles.alert__button,
          [styles[modeColorMap[mode]]]
        )}
      >
        {children}
      </button>
    )
  }

  if (href) {
    return (
      <div
        className={classnames(
          'rounded-lg p-4 border glow-text-opacity-10 border-g-dividers bg-g-elevated',
          styles.alert,
          [styles[modeColorMap[mode]]]
        )}
      >
        <Link color={modeColorMap[mode]} href={href}>
          {children}
        </Link>
      </div>
    )
  }

  return (
    <span
      className={classnames(
        'rounded-lg p-4 border glow-text-opacity-10 border-g-dividers bg-g-elevated',
        styles.alert,
        styles.alert__text,
        [styles[modeColorMap[mode]]]
      )}
    >
      {children}
    </span>
  )
}

export default Alert
